import { ChinaConfigService } from './china-config.service';
import { ConfigService } from './config.service';

export default angular
  .module('sfMobile.services.config', ['sfMobile.config.server'])
  .service('configService', ConfigService)
  .service('chinaConfigService', ChinaConfigService).name;
